<template>
    <div class="aside_1">
        <div class="baseSetting">
            <h4>基本设置</h4>
            <div class="baseInfo">
                <div class="baseInfo_top">
                    <div class="userIcon">
                        <img style="width:70px;height:70px;border-radius: 50%;" :src="avatar">
                    </div>
                    <div class="userDes">
                        <p>
                            昵称：
                            <label v-show="!ctxMap[4].editing">{{nickname? nickname: "（未设置）"}}</label>
                            <img v-show="!ctxMap[4].editing" src="../../../assets/images/mine/nickRename.png" style="margin-left:10px;cursor:pointer;" alt="" @click="settingBtn(4)">

                            <input v-show="ctxMap[4].editing" type="text" v-model="userObj.name" class="nicknameStyle" maxlength="50">
                            <span v-show="ctxMap[4].editing" @click="settingBtn(4)">保存</span>
                        </p>
                        <!-- <p>
                            会员类型：
                            <img src="../../../assets/images/mine/vip.png" alt="">
                            <span>超级VIP会员</span>
                            <span @click="payFn">立即续费</span>
                        </p> -->
                    </div>
                </div>
                <form id="upload" enctype="multipart/form-data" method="post">
                    <el-upload
                    class="upload-demo"
                    action="/realNet/customer/updateCustomerAvatar"
                    name="avatar"
                    :headers="headers"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSucc"
                    :on-error="handleError"
                    :show-file-list="false"
                    list-type="picture">
                    <el-button size="small" type="primary">更改头像</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                    </el-upload>
                </form>
            </div>
        </div>
        <div class="securitySetting">
            <h4>安全设置</h4>
            <div class="securityWrap">
                <div class="securityItem">
                    <div class="securityItemImg">
                        <img src="../../../assets/images/mine/mine_phone.png" alt="">
                    </div>
                    <div class="securityItem_right">
                        <p style="display:flex;justify-content: space-between;">
                            <span class="normalSty" v-if="phoneNum">手机已验证</span>
                            <span class="normalSty" v-else>手机未绑定</span>
                            <span class="activeSty" style="cursor:pointer;" @click="(phoneNum ? changePhoneFn() : bindPhoneFn())">{{(phoneNum ? '修改':'绑定')}}手机号</span>
                        </p>
                        <p class="pSty">
                            <span style="font-size:18px;color:#000;font-weight:bold;" v-if="phoneNum">{{phoneNum}}</span>
                            <span v-else><i style="color:#CADCDC;font-size:16px;">暂无绑定手机号</i></span>
                            <!--<span class="activeSty" style="cursor:pointer;" @click="changePhoneFn">绑定/修改手机号</span>-->
                        </p>
                    </div>
                </div>
                <div class="securityItem">
                    <div class="securityItemImg">
                        <img src="../../../assets/images/mine/mine_email.png" alt="">
                    </div>
                    <div class="securityItem_right">
                        <p style="display:flex;justify-content: space-between;">
                            <span class="normalSty" v-if="email">邮箱已绑定</span>
                            <span class="normalSty" v-else>邮箱未绑定</span>
                            <span class="activeSty" style="cursor:pointer;" @click="(email ? changeEmailFn() : bindEmailFn())">{{(email ? '修改': '绑定')}}邮箱</span>
                        </p>
                        <p>
                            <span style="font-size:18px;color:#000;font-weight:bold;" v-if="email">{{email}}</span>
                            <span v-else><i style="color:#CADCDC;font-size:16px;">暂无邮箱信息</i></span>
                        </p>
                    </div>
                </div>
                <div class="securityItem">
                    <div class="securityItemImg">
                        <img src="../../../assets/images/mine/mine_pwd.png" alt="">
                    </div>
                    <div class="securityItem_right">
                        <p>
                            <span class="activeSty" style="margin-right:35px;cursor:pointer;" @click="changePwdFn">修改密码</span>
                            <!-- <span class="activeSty">找回密码</span> -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="DIY">
            <h4>个性设置</h4>
            <div class="DIYWrap">
                <div class="diyItem" v-for="(ctx,i) in ctxMap.slice(0,4)" :key="ctx.ref">
                    <div class="diyItem_left">
                        {{ctx.label}}：
                        <el-select v-if="ctx.options" v-show="ctx.editing" v-model="userObj[ctx.ref]">
                            <el-option v-for="(opt,n) in ctx.options" :value="opt.val" :key="opt.val">{{opt.text ? opt.text : opt.val}}</el-option>
                        </el-select>
                        <el-date-picker v-if="ctx.type=='date'" v-show="ctx.editing" v-model="userObj[ctx.ref]" type="date" value-format="yyyy-MM-dd"/>
                        <input v-if="ctx.prop" v-show="ctx.editing" v-model="userObj[ctx.ref]" type="text" :maxlength="ctx.maxLen">
                        <span v-show="!ctx.editing">{{userObj[ctx.ref]? userObj[ctx.ref]: "（未设置）"}}</span>
                    </div>
                    <span v-if="ctx.ref !== 'age'" @click="settingBtn(i)">{{ctx.editing? "保存": "设置"}}</span>
                </div>
            </div>
        </div>
        <writePwd :status='writeStatus' :isClose='closeToastFn' @resign="resignFn"></writePwd>
        <edit-email :state="editEmailStatus" :pevalue="userObj.email" @closeState="closeState"></edit-email>
        <edit-phone :state="editPhone" :pevalue="userObj.phoneNum" @closeState="closePhoneState"></edit-phone>
        <bind-phone :state="bindPhone" @closeState="closeBindPhone"></bind-phone>
        <bind-email :state="bindEmail" @closeState="closeBindEmail"></bind-email>
        <bridge-iframe :login-data="loginData"></bridge-iframe>
    </div>
</template>

<script>
    import axios from 'axios';
    import { getToken, setToken, setUser ,getUser} from '../../../utils/auth.js'
    import BUS from '../../../utils/eventBus'
    import writePwd from '../../Toast/writePwd'
    import editEmail from '../../Toast/editEmail'
    import editPhone from '../../Toast/editPhone'
    import bindPhone from '../../Toast/bindPhone'
    import bindEmail from '../../Toast/bindEmail'
    import bridge from '@/components/bridge'
    export default {
        computed: {
            avatar() {
                return this.$store.state.avatar
            },
            nickname() {
                return this.$store.state.name
            }
        },
        data() {
            return {
                userObj: {},
                phoneNum: '',
                email: '',
                loginData: null,
                writeStatus: false,
                editEmailStatus: false,
                editPhone: false,
                bindPhone: false,
                bindEmail: false,
                headers: {},

                ctxMap: [{
                    editing: false,
                    label: "生日",
                    ref: "birthday",
                    type: "date"
                }, {
                    editing: false,
                    label: '年龄',
                    ref: 'age'
                },{
                    editing: false,
                    label: "血型",
                    ref: "bloodGroup",
                    options: [{
                        val: "A"
                    }, {
                        val: "B"
                    }, {
                        val: "AB"
                    }, {
                        val: "O"
                    }],
                }, {
                    editing: false,
                    label: "性别",
                    ref: "sex",
                    options: [{
                        val: "男"
                    }, {
                        val: "女"
                    }],
                }, {
                    editing: false,
                    label: "昵称",
                    prop: "name",
                }]
            }
        },
        methods: {
            resignFn (params) {
              this.loginData = {
                phone: this.phoneNum,
                pwd: params
              }
            },
            payFn() {
                BUS.$emit('drup');
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handleSucc (response,file,filelist) {
              if (response.code === 200){
                this.$store.state.avatar = response.result.avatar
                setUser(JSON.stringify(response.result))
              }
            },
            handleError (err,file,fileList) {
                console.log(err)
            },
            handlePreview(file) {
                console.log(file);
            },
            // 设置个人信息
            settingBtn(status) {
                let ctx = this.ctxMap[status];
                let propName = ctx.prop? ctx.prop: ctx.ref;
                let params = {};
                if (ctx.editing) {
                    if (this.userObj[propName]) {
                        if (propName === 'birthday') {
                            let now = new Date()
                            let birthday = new Date(this.userObj[propName])
                            this.userObj.age = parseInt(now.getFullYear()) - parseInt(birthday.getFullYear())
                        }
                        params.age = this.userObj.age
                        params[propName] = this.userObj[propName];
                        if (ctx.prop && params[propName])
                            this.$store.state.name = params[propName]
                    } else {
                        propName = '';
                    }
                }
                this.$set(this.ctxMap[status], "editing", !ctx.editing)
                if (ctx.editing || !propName)
                    return ;

                axios({
                    method: 'PUT',
                    url: '/realNet/customer/updateCustomer',
                    headers: {
                        token: getToken()
                    },
                    data: params
                }).then((res) =>{
                    if (res.data.message == 'ok') {
                        setUser(JSON.stringify(res.data.result));
                        this.$message({
                            showClose: true,
                            message: "设置成功！",
                            type: 'success',
                            duration: 1000
                        })
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.message,
                            type: 'warning',
                            duration: 1000
                         })
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            closeToastFn() {
                // 关闭弹框
                this.writeStatus = false;
            },
            // 点击修改密码
            changePwdFn() {
                this.writeStatus = true;
            },
            // 修改邮箱
            changeEmailFn() {
                this.editEmailStatus = true
            },
            //修改手机号
            changePhoneFn() {
              this.editPhone = true
            },
            bindPhoneFn() {
              this.bindPhone = true
            },
            bindEmailFn() {
              this.bindEmail = true
            },
            closeState() {
              this.userObj = JSON.parse(getUser())
              this.email = this.userObj.email
              this.editEmailStatus = false
            },
            closePhoneState() {
              this.userObj = JSON.parse(getUser())
              this.phoneNum = this.userObj.phoneNum
              this.editPhone = false
            },
            closeBindPhone() {
              this.userObj = JSON.parse(getUser())
              this.phoneNum = this.userObj.phoneNum
              this.bindPhone = false
            },
            closeBindEmail() {
              this.userObj = JSON.parse(getUser())
              this.email = this.userObj.email
              this.bindEmail = false
            }
        },
        components: {
            writePwd,
            editEmail,
            editPhone,
            bindPhone,
            bindEmail,
            bridgeIframe: bridge
        },
        mounted() {
            this.userObj = JSON.parse(getUser());
            this.phoneNum = this.userObj.phoneNum
            this.email = this.userObj.email
            let headers = {
              token : getToken()
            }
            this.headers = headers
        }
    }
</script>

<style lang='scss' scoped>
    .aside_1 {
        width: 930px;
    }
    .baseSetting {
        margin-bottom: 35px;

        h4 {
            font-size: 14px;
            margin-bottom: 15px;
        }

        .baseInfo {
            width: 100%;
            height: 140px;
            padding: 16px;
            border: 1px solid rgba(234, 236, 237, 1);

            background-color: #F9F9F9;
            box-sizing: border-box;

            .baseInfo_top {
                width: 100%;
                height: 75px;
                margin-bottom: 8px;

                display: flex;
                align-items: center;

                .userIcon {
                    width: 70px;
                    height: 70px;
                    margin-right: 30px;

                    background-color: #D2E0E2;
                    border-radius: 50%;
                    overflow: hidden;
                }
                .userDes {
                    width: 50%;
                    height: 70px;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    font-size: 14px;

                    p {
                        .nicknameStyle {
                            width: 200px;
                            display: inline-block;
                            border: 1px solid #3BC0D0;
                            font-size: 14px;
                            background-color: transparent;
                        }
                        &:nth-last-of-type(1) {
                            display: felx;
                            align-items: center;

                            img {
                                margin: 0 6px;
                            }
                            span {
                                &:nth-last-of-type(1) {
                                    width: 70px;
                                    height: 28px;
                                    margin-left: 10px;
                                    border: 1px solid #BC9D57;

                                    color:#BC9D57;
                                    font-size: 13px;
                                    display: inline-block;
                                    line-height: 28px;
                                    text-align: center;
                                    border-radius: 14px;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }

            .spanSty {
                width: 70px;
                height: 28px;
                border: 1px solid #3BC0D0;

                color: #3BC0D0;
                font-size: 13px;
                border-radius: 14px;
                display: inline-block;
                line-height: 28px;
                text-align: center;
                cursor: pointer;
            }
        }
    }
    .securitySetting {
        margin-bottom: 40px;

        h4 {
            font-size: 14px;
        }
        .securityWrap {
            width: 100%;
            height: 85px;
            margin-top: 15px;

            display: flex;
            justify-content: space-around;
            align-items: center;

            .securityItem {
                width: 300px;
                height: 85px;
                border: 1px solid #3BC0D0;

                background-color: #F9FBFB;

                display: flex;
                align-items: center;

                .securityItemImg {
                    width: 42px;
                    height: 100%;
                    margin: 0 10px;

                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .securityItem_right {
                    width: 220px;
                    height: 100%;
                    padding: 15px 0;

                    box-sizing: border-box;

                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;

                    .normalSty {
                        font-size: 14px;
                        color: #000;
                    }
                    .activeSty {
                        font-size: 14px;
                        color: #2CB5C5;
                    }
                    .pSty {
                        display: flex;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
    .DIY {
        h4 {
            font-size: 14px;
        }
        .DIYWrap {
            width: 926px;
            padding:20px;
            border: 1px solid #EAECED;
            margin-top: 15px;

            box-sizing: border-box;

            .diyItem {
                width: 100%;
                height: 40px;

                font-size: 14px;

                display: flex;
                align-items: center;
                justify-content: space-between;

                & > span {
                    color: #2CB5C5;
                    cursor: pointer;
                }

                .diyItem_left {
                    input {
                        width: 200px;
                        height: 25px;
                        border: 1px solid #3bc0d0;

                        line-height: 25px;
                        font-size: 14px;
                        color: #888888;
                        background-color: transparent;
                    }
                }
            }
        }
    }
</style>
